import type { ErrorCopyFor } from "@amtana/browser";
import type { CAMPAIGN_ERROR_CODES } from "@amtana/campaign-contract";
import { phrase } from "@amtana/i18n/catalog";
import type { Catalogs, Translation } from "@amtana/i18n/catalog";

// What a user reads when a campaign action fails (packages/module ADR-001).

const EN = {
  notFoundTitle: "This campaign doesn't exist",
  notFoundDescription: "It may have been deleted. Open your campaigns to pick another.",
  limitReachedTitle: "You've reached your campaign limit",
  limitReachedDescription: "Delete a campaign or upgrade your plan to create more.",
  notReadyTitle: "The campaign isn't ready to launch",
  notReadyDescription: "Complete the required steps in Review & Launch first.",
  lockedTitle: "This campaign has finished",
  lockedDescription: "A finished campaign can't be changed. Create a new one instead.",
} as const;

const ES: Translation<typeof EN> = {
  notFoundTitle: "Esta campaña no existe",
  notFoundDescription: "Puede que la hayan eliminado. Abre tus campañas para elegir otra.",
  limitReachedTitle: "Llegaste al límite de campañas",
  limitReachedDescription: "Elimina una campaña o mejora tu plan para crear más.",
  notReadyTitle: "La campaña aún no está lista para lanzarse",
  notReadyDescription: "Primero completa los pasos obligatorios en Revisar y lanzar.",
  lockedTitle: "Esta campaña ya terminó",
  lockedDescription: "Una campaña terminada no se puede cambiar. Crea una nueva.",
};

export const CAMPAIGN_ERROR_CATALOGS: Catalogs<typeof EN> = { en: EN, es: ES };

export const CAMPAIGN_ERROR_COPY = {
  campaign_not_found: {
    title: phrase(CAMPAIGN_ERROR_CATALOGS, "notFoundTitle"),
    description: phrase(CAMPAIGN_ERROR_CATALOGS, "notFoundDescription"),
  },
  campaign_limit_reached: {
    title: phrase(CAMPAIGN_ERROR_CATALOGS, "limitReachedTitle"),
    description: phrase(CAMPAIGN_ERROR_CATALOGS, "limitReachedDescription"),
  },
  campaign_not_ready: {
    title: phrase(CAMPAIGN_ERROR_CATALOGS, "notReadyTitle"),
    description: phrase(CAMPAIGN_ERROR_CATALOGS, "notReadyDescription"),
  },
  campaign_locked: {
    title: phrase(CAMPAIGN_ERROR_CATALOGS, "lockedTitle"),
    description: phrase(CAMPAIGN_ERROR_CATALOGS, "lockedDescription"),
  },
} satisfies ErrorCopyFor<typeof CAMPAIGN_ERROR_CODES>;
